const doc = [({"da":({"js":({"admin":({"tenant_photo_products":({"visible_in_shop":({"the_tenant_photo_product_was_saved":"Tenantfotoproduktet blev gemt."})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;